import { ApiService } from "./api.service";
export default class RateService extends ApiService {
  template = "defaultTemplate";
  namespace = "field";
  icon = "WindowWithText";
  action = "action";
  favicon = "BlueCube";

  Width = 600;
  DOMAIN = -6;

  constructor() {
    super("fields");
  }
}
